import React, { useEffect, useRef, useState } from 'react'
import { API_URL } from '../../env'
import axios from 'axios'
import { ThreeCircles } from 'react-loader-spinner'
import { Fade, Zoom } from 'react-awesome-reveal'
import { toast } from 'react-toastify'
import { Accordion, Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faClock, faCreditCard, faEnvelope, faFileExcel, faFilePdf, faLandmark, faLocationDot, faPenClip, faPhone, faPlus, faRulerCombined, faUserTag } from '@fortawesome/free-solid-svg-icons'
import '../../styles/Admin/AdminCustomer.css'
import AccordionItem from '../Utils/AccordionItem'
import Badge from '../Utils/Badge'
import Modal from '../Utils/Modal'
import Button from '../Utils/Button'
import InputText from '../Input/InputText'
import InputSwitch from '../Input/InputSwitch'
import { useNavigate } from 'react-router-dom'
import XLSX from 'xlsx-js-style'
import InputSearch from '../Input/InputSearch'

function AdminCustomer({ adminRouter, adminRouterPrev, setAdminRouterPrev, itemDisplay, customers, getCustomers, getDiagnostics, getPayments }) {

    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)
    const [accordionIndex, setAccordionIndex] = useState(null)
    const [customersDisplay, setCustomersDisplay] = useState(customers)
    const [displayAddCustomerModal, setDisplayAddCustomerModal] = useState(false)
    const [search, setSearch] = useState("")

    const firstnameAddRef = useRef(null)
    const [firstnameAdd, setFirstnameAdd] = useState("")
    const [firstnameAddError, setFirstnameAddError] = useState(null)
    const lastnameAddRef = useRef(null)
    const [lastnameAdd, setLastnameAdd] = useState("")
    const [lastnameAddError, setLastnameAddError] = useState(null)
    const addressStreetAddRef = useRef(null)
    const [addressStreetAdd, setAddressStreetAdd] = useState("")
    const [addressStreetAddError, setAddressStreetAddError] = useState(null)
    const addressCityAddRef = useRef(null)
    const [addressCityAdd, setAddressCityAdd] = useState("")
    const [addressCityAddError, setAddressCityAddError] = useState(null)
    const addressZipcodeAddRef = useRef(null)
    const [addressZipcodeAdd, setAddressZipcodeAdd] = useState("")
    const [addressZipcodeAddError, setAddressZipcodeAddError] = useState(null)
    const emailAddRef = useRef(null)
    const [emailAdd, setEmailAdd] = useState("")
    const [emailAddError, setEmailAddError] = useState(null)
    const phoneAddRef = useRef(null)
    const [phoneAdd, setPhoneAdd] = useState("")
    const [phoneAddError, setPhoneAddError] = useState(null)
    const [createDiagnostic, setCreateDiagnostic] = useState(false)

    const firstnameUpdateRef = useRef(null)
    const [firstnameUpdate, setFirstnameUpdate] = useState("")
    const [firstnameUpdateError, setFirstnameUpdateError] = useState(null)
    const lastnameUpdateRef = useRef(null)
    const [lastnameUpdate, setLastnameUpdate] = useState("")
    const [lastnameUpdateError, setLastnameUpdateError] = useState(null)
    const addressStreetUpdateRef = useRef(null)
    const [addressStreetUpdate, setAddressStreetUpdate] = useState("")
    const [addressStreetUpdateError, setAddressStreetUpdateError] = useState(null)
    const addressCityUpdateRef = useRef(null)
    const [addressCityUpdate, setAddressCityUpdate] = useState("")
    const [addressCityUpdateError, setAddressCityUpdateError] = useState(null)
    const addressZipcodeUpdateRef = useRef(null)
    const [addressZipcodeUpdate, setAddressZipcodeUpdate] = useState("")
    const [addressZipcodeUpdateError, setAddressZipcodeUpdateError] = useState(null)
    const emailUpdateRef = useRef(null)
    const [emailUpdate, setEmailUpdate] = useState("")
    const [emailUpdateError, setEmailUpdateError] = useState(null)
    const phoneUpdateRef = useRef(null)
    const [phoneUpdate, setPhoneUpdate] = useState("")
    const [phoneUpdateError, setPhoneUpdateError] = useState(null)

    const customersData = customers

    useEffect(() => {

        displayRouterItem()

    }, [])

    useEffect(() => {

        setCustomersDisplay(customers)

    }, [customers])

    function displayRouterItem() {

        if (itemDisplay !== "0") {

            setAccordionIndex(customers.indexOf(customers.find((item) => item.id === parseInt(itemDisplay))))
            window.scrollTo({ top: 230 + (60 * (customers.indexOf(customers.find((item) => item.id === parseInt(itemDisplay))) - 1)), behavior: 'instant' })
        }

    }

    function exportExcel() {

        const wb = XLSX.utils.book_new()
        let dataTitle = [
            { v: "E5M Diagnostics", s: { font: { name: "Brush Script MT", bold: true, sz: 20, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
        ]
        let dataHeader = [
            { v: "Date", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Nom", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Email", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Téléphone", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Adresse", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
        ]
        let dataBody = []
        customersDisplay.forEach((item) => {
            dataBody.push([
                { v: item.createdAt, s: { font: { name: "Calibri", sz: 12, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
                { v: item.firstname + " " + item.lastname, s: { font: { name: "Calibri", sz: 12, } } },
                { v: item.email, s: { font: { name: "Calibri", sz: 12, } } },
                { v: item.phone, s: { font: { name: "Calibri", sz: 12, } } },
                { v: item.addressStreet + ", " + item.addressZipcode + " " + item.addressCity }
            ])
        })
        const ws = XLSX.utils.aoa_to_sheet([dataTitle, [], [], dataHeader, ...dataBody])
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 1, c: 4 } }, { s: { r: 2, c: 0 }, e: { r: 2, c: 4 } }]
        ws['!cols'] = [{ wch: 20 }, { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 30 }]
        XLSX.utils.book_append_sheet(wb, ws, "E5M Diagnostics Sheet1")
        XLSX.writeFile(wb, "E5M Diagnostics Export (" + new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' }) + ").xlsx")

    }

    function addCustomer() {

        setIsLoading(true)
        var error = []
        if (!firstnameAddRef.current.nameValidation(firstnameAdd)) {
            error.push("Le prénom est incorrect")
        }
        if (!lastnameAddRef.current.nameValidation(lastnameAdd)) {
            error.push("Le nom est incorrect")
        }
        if (!addressStreetAddRef.current.textValidation(addressStreetAdd)) {
            error.push("L'adresse est incorrect")
        }
        if (!addressCityAddRef.current.nameValidation(addressCityAdd)) {
            error.push("La ville est incorrect")
        }
        if (!addressZipcodeAddRef.current.textValidation(addressZipcodeAdd)) {
            error.push("Le code postal est incorrect")
        }
        if (!emailAddRef.current.emailValidationOnBlur(emailAdd)) {
            error.push("L'email est incorrect")
        }
        if (!phoneAddRef.current.phoneValidationOnBlur(phoneAdd)) {
            error.push("Le téléphone est incorrect")
        }
        const phoneFormat = phoneAdd.replace(/ /g, '')
        if (error.length > 0) {
            error.map((item) => toast.error(item))
            setIsLoading(false)
        } else {
            const toastId = toast.loading("Ajout...")
            axios.post(API_URL + "customer", {
                firstname: firstnameAdd,
                lastname: lastnameAdd,
                addressStreet: addressStreetAdd,
                addressCity: addressCityAdd,
                addressZipcode: addressZipcodeAdd,
                email: emailAdd,
                phone: phoneFormat,
            }).then((response) => {
                if (response.data === "CUSTOMER_CREATED") {
                    toast.update(toastId, { render: "Client ajouté", type: "success", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                    getCustomers()
                    getDiagnostics()
                    getPayments()
                    setFirstnameAdd("")
                    setFirstnameAddError(null)
                    setLastnameAdd("")
                    setLastnameAddError(null)
                    setAddressStreetAdd("")
                    setAddressStreetAddError(null)
                    setAddressCityAdd("")
                    setAddressCityAddError(null)
                    setAddressZipcodeAdd("")
                    setAddressZipcodeAddError(null)
                    setEmailAdd("")
                    setEmailAddError(null)
                    setPhoneAdd("")
                    setPhoneAddError(null)
                    setAccordionIndex(null)
                    setDisplayAddCustomerModal(false)
                    if (createDiagnostic) {
                        setAdminRouterPrev(adminRouter)
                        navigate('/administration/diagnostic/addDiagnostic')
                    }
                }
                setIsLoading(false)
            }).catch((error) => {
                if (error.response) {
                    var errorMessage = error.response.data.message
                    if (errorMessage === "ERROR_CUSTOMER_ALREADY_EXISTS") {
                        errorMessage = "Le client éxiste déjà"
                    } else if (errorMessage === "ERROR_CUSTOMER_CREATION") {
                        errorMessage = "Erreur lors de la création du client"
                    }
                }
                toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                setIsLoading(false)
            })
        }

    }

    function updateCustomer(customerId) {

        setIsLoading(true)
        const customer = customers.find((item) => item.id === customerId)
        var error = []
        var firstnameFormat = null
        var lastnameFormat = null
        var addressStreetFormat = null
        var addressCityFormat = null
        var addressZipcodeFormat = null
        var emailFormat = null
        var phoneFormat = null
        if (!firstnameUpdate && !lastnameUpdate && !addressStreetUpdate && !addressCityUpdate && !addressZipcodeUpdate && !emailUpdate && !phoneUpdate) {
            error.push("Aucun changement détecté")
        } else {
            if (!firstnameUpdate) {
                firstnameFormat = customer.firstname
            } else if (!firstnameUpdateRef.current.nameValidation(firstnameUpdate)) {
                error.push("Le prénom est incorrect")
            } else {
                firstnameFormat = firstnameUpdate
            }
            if (!lastnameUpdate) {
                lastnameFormat = customer.lastname
            } else if (!lastnameUpdateRef.current.nameValidation(lastnameUpdate)) {
                error.push("Le nom est incorrect")
            } else {
                lastnameFormat = lastnameUpdate
            }
            if (!addressStreetUpdate) {
                addressStreetFormat = customer.addressStreet
            } else if (!addressStreetUpdateRef.current.textValidation(addressStreetUpdate)) {
                error.push("L'adresse est incorrect")
            } else {
                addressStreetFormat = addressStreetUpdate
            }
            if (!addressCityUpdate) {
                addressCityFormat = customer.addressCity
            } else if (!addressCityUpdateRef.current.nameValidation(addressCityUpdate)) {
                error.push("La ville est incorrect")
            } else {
                addressCityFormat = addressCityUpdate
            }
            if (!addressZipcodeUpdate) {
                addressZipcodeFormat = customer.addressZipcode
            } else if (!addressZipcodeUpdateRef.current.textValidation(addressZipcodeUpdate)) {
                error.push("Le code postal est incorrect")
            } else {
                addressZipcodeFormat = addressZipcodeUpdate
            }
            if (!emailUpdate) {
                emailFormat = customer.email
            } else if (!emailUpdateRef.current.emailValidationOnBlur(emailUpdate)) {
                error.push("L'email est incorrect")
            } else {
                emailFormat = emailUpdate
            }
            if (!phoneUpdate) {
                phoneFormat = customer.phone.replace(/ /g, '')
            } else if (!phoneUpdateRef.current.phoneValidation(phoneUpdate)) {
                error.push("Le téléphone est incorrect")
            } else {
                phoneFormat = phoneUpdate.replace(/ /g, '')
            }
        }
        if (error.length > 0) {
            error.map((item) => toast.error(item))
            setIsLoading(false)
        } else {
            const toastId = toast.loading("Modification...")
            axios.put(API_URL + "customer/" + customerId, {
                firstname: firstnameFormat,
                lastname: lastnameFormat,
                addressStreet: addressStreetFormat,
                addressCity: addressCityFormat,
                addressZipcode: addressZipcodeFormat,
                email: emailFormat,
                phone: phoneFormat,
            }).then((response) => {
                if (response.data === "CUSTOMER_UPDATED") {
                    toast.update(toastId, { render: "Client modifié", type: "success", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                    getCustomers()
                    setFirstnameUpdate("")
                    setFirstnameUpdateError(null)
                    setLastnameUpdate("")
                    setLastnameUpdateError(null)
                    setAddressStreetUpdate("")
                    setAddressStreetUpdateError(null)
                    setAddressCityUpdate("")
                    setAddressCityUpdateError(null)
                    setAddressZipcodeUpdate("")
                    setAddressZipcodeUpdateError(null)
                    setEmailUpdate("")
                    setEmailUpdateError(null)
                    setPhoneUpdate("")
                    setPhoneUpdateError(null)
                    setAccordionIndex(null)
                }
                setIsLoading(false)
            }).catch((error) => {
                if (error.response) {
                    var errorMessage = error.response.data.message
                    if (errorMessage === "ERROR_CUSTOMER_NOT_FOUND") {
                        errorMessage = "Le client est introuvable"
                    } else if (errorMessage === "ERROR_CUSTOMER_UPDATE") {
                        errorMessage = "Erreur lors de la modification du client"
                    }
                }
                toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                setIsLoading(false)
            })
        }

    }

    return (

        <div id='adminCustomer'>
            <Fade direction={adminRouterPrev === 'diagnostic' ? 'right' : 'left'} duration={500} triggerOnce={true}>
                <div className='adminBarButton'>
                    <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPlus} />} text={'Ajouter'} rounded={true} onClick={() => setDisplayAddCustomerModal(true)} />
                    <Button theme={'dark'} icon={<FontAwesomeIcon icon={faFileExcel} />} text={'Exporter'} rounded={true} onClick={() => exportExcel()} />
                    <InputSearch
                        theme={'dark'}
                        type={'customer'}
                        search={search} setSearch={setSearch}
                        data={customersData}
                        results={customersDisplay} setResults={setCustomersDisplay}
                        placeholder={'Rechercher par date, prénom, nom, email, téléphone, ville ou CP'}
                    />
                </div>
                <Modal
                    displayModal={displayAddCustomerModal}
                    setDisplayModal={setDisplayAddCustomerModal}
                    header={'Ajouter un client'}
                    body={
                        <>
                            <Zoom duration={500}>
                                <div>
                                    <InputText
                                        type={'name'}
                                        theme={'light'}
                                        ref={firstnameAddRef}
                                        text={firstnameAdd} setText={setFirstnameAdd}
                                        textError={firstnameAddError} setTextError={setFirstnameAddError}
                                        icon={<FontAwesomeIcon icon={faUserTag} />}
                                        placeholder={"Prénom"}
                                        maxLength={64}
                                        onPressEnter={() => lastnameAddRef.current.inputTextRef.current.focus()}
                                    />
                                </div>
                            </Zoom>
                            <Zoom duration={500} delay={50}>
                                <div>
                                    <InputText
                                        type={'name'}
                                        theme={'light'}
                                        ref={lastnameAddRef}
                                        text={lastnameAdd} setText={setLastnameAdd}
                                        textError={lastnameAddError} setTextError={setLastnameAddError}
                                        icon={<FontAwesomeIcon icon={faUserTag} />}
                                        placeholder={"Nom"}
                                        maxLength={64}
                                        onPressEnter={() => addressStreetAddRef.current.inputTextRef.current.focus()}
                                    />
                                </div>
                            </Zoom>
                            <Zoom duration={500} delay={100}>
                                <div>
                                    <InputText
                                        type={'text'}
                                        theme={'light'}
                                        ref={addressStreetAddRef}
                                        text={addressStreetAdd} setText={setAddressStreetAdd}
                                        textError={addressStreetAddError} setTextError={setAddressStreetAddError}
                                        icon={<FontAwesomeIcon icon={faLocationDot} />}
                                        placeholder={"N° et rue"}
                                        maxLength={64}
                                        onPressEnter={() => addressCityAddRef.current.inputTextRef.current.focus()}
                                    />
                                </div>
                            </Zoom>
                            <Zoom duration={500} delay={150}>
                                <div>
                                    <InputText
                                        type={'name'}
                                        theme={'light'}
                                        ref={addressCityAddRef}
                                        text={addressCityAdd} setText={setAddressCityAdd}
                                        textError={addressCityAddError} setTextError={setAddressCityAddError}
                                        icon={<FontAwesomeIcon icon={faLocationDot} />}
                                        placeholder={"Ville"}
                                        maxLength={64}
                                        onPressEnter={() => addressZipcodeAddRef.current.inputTextRef.current.focus()}
                                    />
                                </div>
                            </Zoom>
                            <Zoom duration={500} delay={200}>
                                <div>
                                    <InputText
                                        type={'text'}
                                        theme={'light'}
                                        ref={addressZipcodeAddRef}
                                        text={addressZipcodeAdd} setText={setAddressZipcodeAdd}
                                        textError={addressZipcodeAddError} setTextError={setAddressZipcodeAddError}
                                        icon={<FontAwesomeIcon icon={faLocationDot} />}
                                        placeholder={"Code postal"}
                                        maxLength={5}
                                        onPressEnter={() => emailAddRef.current.inputTextRef.current.focus()}
                                    />
                                </div>
                            </Zoom>
                            <Zoom duration={500} delay={250}>
                                <div>
                                    <InputText
                                        type={'email'}
                                        theme={'light'}
                                        ref={emailAddRef}
                                        text={emailAdd} setText={setEmailAdd}
                                        textError={emailAddError} setTextError={setEmailAddError}
                                        icon={<FontAwesomeIcon icon={faEnvelope} />}
                                        placeholder={"Email"}
                                        maxLength={256}
                                        onPressEnter={() => phoneAddRef.current.inputTextRef.current.focus()}
                                    />
                                </div>
                            </Zoom>
                            <Zoom duration={500} delay={300}>
                                <div>
                                    <InputText
                                        type={'phone'}
                                        theme={'light'}
                                        ref={phoneAddRef}
                                        text={phoneAdd} setText={setPhoneAdd}
                                        textError={phoneAddError} setTextError={setPhoneAddError}
                                        icon={<FontAwesomeIcon icon={faPhone} />}
                                        placeholder={"Téléphone"}
                                        maxLength={14}
                                        onPressEnter={() => addCustomer()}
                                    />
                                </div>
                            </Zoom>
                            <Zoom duration={500} delay={350}>
                                <div>
                                    <InputSwitch
                                        value={createDiagnostic} setValue={setCreateDiagnostic}
                                        label={"Continuer ensuite avec la création d'un diagnostic pour ce client"}
                                    />
                                </div>
                            </Zoom>
                            <Zoom duration={500} delay={400}>
                                <div>
                                    <div id='adminInfoAddButton'>
                                        {!isLoading ?
                                            <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPlus} />} text={'Ajouter'} rounded={true} onClick={() => addCustomer()} />
                                            :
                                            <ThreeCircles visible={true} height={"40"} width={"40"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderDark')} />
                                        }
                                    </div>
                                </div>
                            </Zoom>
                        </>
                    }
                />
                <Accordion defaultActiveKey={accordionIndex} activeKey={accordionIndex}>
                    {customersDisplay.map((item, index) => {
                        return (
                            <AccordionItem
                                key={item.id}
                                indexKey={index}
                                index={accordionIndex}
                                setIndex={setAccordionIndex}
                                header={item.firstname + " " + item.lastname + " - " + item.email + " - " + item.phone + " (" + item.addressCity + " " + item.addressZipcode + ")"}
                                body={
                                    <Row>
                                        <Col>
                                            <table className='adminInfo'>
                                                <tbody>
                                                    <tr className='adminInfoText'>
                                                        <td className='adminInfoTextIcon'>
                                                            <FontAwesomeIcon icon={faCalendar} />
                                                        </td>
                                                        <td>
                                                            Créé le {item.createdAt}
                                                        </td>
                                                    </tr>
                                                    <tr className='adminInfoText'>
                                                        <td className='adminInfoTextIcon'>
                                                            <FontAwesomeIcon icon={faCalendar} />
                                                        </td>
                                                        <td>
                                                            Modifié le {item.updatedAt}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <InputText
                                                type={'name'}
                                                theme={'light'}
                                                ref={firstnameUpdateRef}
                                                text={firstnameUpdate} setText={setFirstnameUpdate}
                                                textError={firstnameUpdateError} setTextError={setFirstnameUpdateError}
                                                icon={<FontAwesomeIcon icon={faUserTag} />}
                                                placeholder={item.firstname}
                                                maxLength={64}
                                                onPressEnter={() => lastnameUpdateRef.current.inputTextRef.current.focus()}
                                            />
                                            <InputText
                                                type={'name'}
                                                theme={'light'}
                                                ref={lastnameUpdateRef}
                                                text={lastnameUpdate} setText={setLastnameUpdate}
                                                textError={lastnameUpdateError} setTextError={setLastnameUpdateError}
                                                icon={<FontAwesomeIcon icon={faUserTag} />}
                                                placeholder={item.lastname}
                                                maxLength={64}
                                                onPressEnter={() => addressStreetUpdateRef.current.inputTextRef.current.focus()}
                                            />
                                            <InputText
                                                type={'text'}
                                                theme={'light'}
                                                ref={addressStreetUpdateRef}
                                                text={addressStreetUpdate} setText={setAddressStreetUpdate}
                                                textError={addressStreetUpdateError} setTextError={setAddressStreetUpdateError}
                                                icon={<FontAwesomeIcon icon={faLocationDot} />}
                                                placeholder={item.addressStreet}
                                                maxLength={64}
                                                onPressEnter={() => addressCityUpdateRef.current.inputTextRef.current.focus()}
                                            />
                                            <InputText
                                                type={'name'}
                                                theme={'light'}
                                                ref={addressCityUpdateRef}
                                                text={addressCityUpdate} setText={setAddressCityUpdate}
                                                textError={addressCityUpdateError} setTextError={setAddressCityUpdateError}
                                                icon={<FontAwesomeIcon icon={faLocationDot} />}
                                                placeholder={item.addressCity}
                                                maxLength={64}
                                                onPressEnter={() => addressZipcodeUpdateRef.current.inputTextRef.current.focus()}
                                            />
                                            <InputText
                                                type={'text'}
                                                theme={'light'}
                                                ref={addressZipcodeUpdateRef}
                                                text={addressZipcodeUpdate} setText={setAddressZipcodeUpdate}
                                                textError={addressZipcodeUpdateError} setTextError={setAddressZipcodeUpdateError}
                                                icon={<FontAwesomeIcon icon={faLocationDot} />}
                                                placeholder={item.addressZipcode}
                                                maxLength={5}
                                                onPressEnter={() => emailUpdateRef.current.inputTextRef.current.focus()}
                                            />
                                            <InputText
                                                type={'email'}
                                                theme={'light'}
                                                ref={emailUpdateRef}
                                                text={emailUpdate} setText={setEmailUpdate}
                                                textError={emailUpdateError} setTextError={setEmailUpdateError}
                                                icon={<FontAwesomeIcon icon={faEnvelope} />}
                                                placeholder={item.email}
                                                maxLength={256}
                                                onPressEnter={() => phoneUpdateRef.current.inputTextRef.current.focus()}
                                            />
                                            <InputText
                                                type={'phone'}
                                                theme={'light'}
                                                ref={phoneUpdateRef}
                                                text={phoneUpdate} setText={setPhoneUpdate}
                                                textError={phoneUpdateError} setTextError={setPhoneUpdateError}
                                                icon={<FontAwesomeIcon icon={faPhone} />}
                                                placeholder={item.phone}
                                                maxLength={14}
                                                onPressEnter={() => updateCustomer(item.id)}
                                            />
                                            <div className='adminInfoUpdateButton'>
                                                <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPenClip} />} text={'Modifier'} rounded={true} onClick={() => updateCustomer(item.id)} />
                                            </div>
                                        </Col>
                                        <Col>
                                            {item.diagnostics.map((itemDiagnostic) => {
                                                return (
                                                    <Zoom key={itemDiagnostic.id} duration={500} delay={100}>
                                                        <div className='adminCard' onClick={() => { setAdminRouterPrev(adminRouter); navigate('/administration/diagnostic/' + itemDiagnostic.id) }}>
                                                            <div className='adminCardTitle'>
                                                                <FontAwesomeIcon icon={faRulerCombined} className='adminCardTitleIcon' />
                                                                {itemDiagnostic.type}
                                                            </div>
                                                            <table>
                                                                <tbody>
                                                                    <tr className='adminCardText'>
                                                                        <td className='adminCardTextIcon'>
                                                                            <FontAwesomeIcon icon={faClock} />
                                                                        </td>
                                                                        <td>
                                                                            <Badge theme={itemDiagnostic.status === 'En cours' ? 'blue' : itemDiagnostic.status === 'Terminé' ? 'green' : 'red'} text={itemDiagnostic.status} />
                                                                        </td>
                                                                    </tr>
                                                                    <tr className='adminCardText'>
                                                                        <td className='adminCardTextIcon'>
                                                                            <FontAwesomeIcon icon={faCalendar} />
                                                                        </td>
                                                                        <td>
                                                                            {itemDiagnostic.createdAt}
                                                                        </td>
                                                                    </tr>
                                                                    <tr className='adminCardText'>
                                                                        <td className='adminCardTextIcon'>
                                                                            <FontAwesomeIcon icon={faFilePdf} />
                                                                        </td>
                                                                        <td>
                                                                            {itemDiagnostic.file}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </Zoom>
                                                )
                                            })}
                                        </Col>
                                        <Col>
                                            {item.payments.map((itemPayment) => {
                                                return (
                                                    <Zoom key={itemPayment.id} duration={500} delay={200}>
                                                        <div className='adminCard' onClick={() => { setAdminRouterPrev(adminRouter); navigate('/administration/payment/' + itemPayment.id) }}>
                                                            <div className='adminCardTitle'>
                                                                <FontAwesomeIcon icon={faCreditCard} className='adminCardTitleIcon' />
                                                                {itemPayment.amount}
                                                            </div>
                                                            <table>
                                                                <tbody>
                                                                    <tr className='adminCardText'>
                                                                        <td className='adminCardTextIcon'>
                                                                            <FontAwesomeIcon icon={faLandmark} />
                                                                        </td>
                                                                        <td>
                                                                            <Badge theme={itemPayment.status === 'Non payé' ? 'grey' : itemPayment.status === 'En cours' ? 'blue' : itemPayment.status === 'Payé' ? 'green' : 'red'} text={itemPayment.status} />
                                                                        </td>
                                                                    </tr>
                                                                    <tr className='adminCardText'>
                                                                        <td className='adminCardTextIcon'>
                                                                            <FontAwesomeIcon icon={faCalendar} />
                                                                        </td>
                                                                        <td>
                                                                            {itemPayment.createdAt}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </Zoom>
                                                )
                                            })}
                                        </Col>
                                    </Row>
                                }
                                animated={false}
                            />
                        )
                    })}
                </Accordion>
            </Fade>
        </div>

    )

}

export default AdminCustomer